import { FC } from 'react';
import { css, Theme } from '@emotion/react';
import LinearProgress from '@mui/material/LinearProgress';
import { Typography } from 'client/components/Typography';

const statisticStyle = (theme: Theme) => css`
  display: flex;
  flex-direction: column;

  .typography {
    padding-left: 0.9rem;
  }

  .statistic {
    margin-top: -0.2rem;
  }

  .MuiLinearProgress-root {
    margin-top: 0.2rem;
    height: 1rem;
    border-radius: 3px;
    background-color: ${theme.color.grey[60]};
  }

  .MuiLinearProgress-bar {
    background-color: ${theme.color.primary[100]};
  }
`;

export interface StatisticProps {
  title: string;
  amount: number;
  decimals?: number;
  unit?: string;
  max?: number | string;
  progress?: number;
}

// U+202F Narrow no-break space
const seperator = ' ';

export const Statistic: FC<StatisticProps> = ({ title, amount, decimals = null, unit = null, max = null, progress = null, ...other }) => {
  const amountValue = decimals !== null ? amount.toFixed(decimals) : amount;

  const unitElement = !!unit && (
    <>
      {seperator}
      <small>{unit}</small>
    </>
  );

  return (
    <div className="statistic" css={statisticStyle} {...other}>
      <Typography variant="body2" component="label">
        {title}
      </Typography>
      <Typography variant="statistic">
        <b>
          {amountValue}
          {unitElement}
        </b>
        {max !== null && (
          <>
            {' / '}
            {max}
            {unitElement}
          </>
        )}
      </Typography>
      {progress !== null && <LinearProgress variant="determinate" value={isNaN(progress) ? 0 : progress} />}
    </div>
  );
};
